export default {"src":"/_next/static/image/public/images/flags/flag_673.0a0658edf33b2b1d625fe5a22e4b1e49.svg","height":16,"width":24};